import React from 'react';
import classNames from 'classnames';

import { Avatar, AvatarSize } from '@vyaguta/vyaguta-ui';

import { getEmpImageUrl } from 'utils/string';

type ValueType = {
  empId?: string | number;
  employeeId?: string | number;
};

export interface AvatarComponentProps {
  empId?: string;
  label?: string;
  value?: string | ValueType;
  customClassName?: string;
  size?: AvatarSize;
}

const normalizeEmpId = (id?: string | number | null): string | undefined => {
  if (id === null || id === undefined || id === '') {
    return undefined;
  }

  return String(id);
};

export const resolveAvatarEmpId = ({
  empId,
  value,
}: Pick<AvatarComponentProps, 'empId' | 'value'>): string | undefined => {
  const resolvedFromProp = normalizeEmpId(empId);

  if (resolvedFromProp) {
    return resolvedFromProp;
  }

  if (typeof value === 'object' && value !== null) {
    return normalizeEmpId(value.empId) ?? normalizeEmpId(value.employeeId);
  }

  return undefined;
};

/**
 * @param  {Object} options
 * @param  {{empId:string, label:string, value:Number|number | {{empId: number, id: number ....}}}} options
 * @returns {JSX}
 */
const AvatarComponent: React.FC<AvatarComponentProps> = ({ empId, label, value, customClassName, size = 'small' }) => {
  const resolvedEmpId = resolveAvatarEmpId({ empId, value });

  return (
    <div className="d-flex">
      <Avatar image={getEmpImageUrl(resolvedEmpId)} alt={label} size={size} className={classNames(customClassName)} />
      <div className="d-flex align-items-center ml-5">{label}</div>
    </div>
  );
};

export default AvatarComponent;
